export const defaultTranslations = {
  logout: 'Log out',
  systemTime: 'System time',
  noResultsFound: 'No results found',
  fraction: 'Fraction',
  fractionIn: 'Fraction in',
  overallFraction: 'Overall fraction',
  exposureTitle: 'Exposure',
  exposureSource: 'Source',
  exposureDestination: 'Destination',
  exposureNoSourceData: 'There is no exposure source data yet',
  exposureNoDestinationData: 'There is no exposure destination data yet',
}
